export interface ISystemLastHeartbeat {
    systemTime: Date;
}

export class SystemLastHeartbeat implements ISystemLastHeartbeat {
    systemTime: Date;

    constructor(systemTime: Date) {
        this.systemTime = systemTime;
    }
}



/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/systemHealthRetriever/system-last-heart-beat.ts
 **/